import { Component } from 'preact';
import { MainColorGroup, mainColorGroups, rgbToHex } from '../../common/data/colors.js';

export interface ColorPresetProps {
	colors: number[][];
	groups: readonly MainColorGroup[];
	onClick: () => void;
}

export class ColorPreset extends Component<ColorPresetProps, {}> {
	
	render(props: ColorPresetProps) {
		return <canvas className="color-preset" onClick={props.onClick} />;
	}
	shouldComponentUpdate() {
		return false;
	}
	componentDidMount() {
		this.paint(this.props);
	}
	componentWillReceiveProps(props: ColorPresetProps) {
		if (props.colors.join(',') != this.props.colors.join(',')) this.paint(props);
	}

	paint(props: ColorPresetProps) {
	
		const canvas = this.base as HTMLCanvasElement;
		const size = Math.round(canvas.getBoundingClientRect().width * devicePixelRatio * 2);
		
		const count = props.groups.length;
		const degrees = Math.PI * (2 / count);
		const rot = count % 2 == 0 ? degrees * 2 : degrees * 0.75;

		canvas.width = size;
		canvas.height = size;
		const center = size * 0.5;
		const radius = size;
		const margin = 0;
		const ctx = canvas.getContext('2d')!;
		ctx.imageSmoothingQuality = 'high';

		props.colors.filter((col, i) => props.groups.includes(mainColorGroups[i]!)).forEach((color, i) => {
			const sx = center + margin * Math.cos(rot + (i + 0.5) * degrees);
			const sy = center + margin * Math.sin(rot + (i + 0.5) * degrees);
			ctx.fillStyle = rgbToHex(color);
			ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
			ctx.beginPath();
			ctx.moveTo(sx, sy);
			ctx.lineTo(sx + Math.cos(rot + i * degrees) * radius, sy + Math.sin(rot + i * degrees) * radius);
			ctx.arc(sx, sy, radius, rot + i * degrees, rot + (i + 1) * degrees);
			ctx.moveTo(sx + Math.cos(rot + (i + 1) * degrees) * radius, sy + Math.sin(rot + (i + 1) * degrees) * radius);
			ctx.lineTo(sx, sy);
			ctx.fill();
			ctx.stroke();
		});
		
	}

}
